import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import InputMask from 'react-input-mask';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import Button from 'components/Button';
import PageTitle from 'components/PageTitle';
import CarItem from 'components/CarItem';

import { URLS } from 'config';

import './stylestemp.scss';
import containerActions from './actions';

class Payment extends React.Component {
	state = {
	  isOpen: true,
	  successfulPayment: false,
	  approved: {},
	  card: '',
	  brand: '',
	  valid: '',
	  code: '',
	  inputDataValidation: '',
	  inputCardNumberValidation: '',
	  inputNameValidation: '',
	  inputCodeValidation: ''
	}

	componentWillUpdate() {
	}
  inputNameValidation = (focus) => {
    const patt = new RegExp(/^\w+\s+[\w-.]+$|^\w+\s+[\w-.]+\s+[\w-.]+$/g);

    if (focus === false) {
      if ((this.state.brand.trim().length > 0 &&
      !patt.test(this.state.brand.trim())) ||
      (this.state.brand.trim().length > 100)) {
        this.setState({
          inputNameValidation: 'err'
        });
      } else {
        this.setState({
          inputNameValidation: 'ok'
        });
      }
    }
    if (focus === true) {
      this.setState({
        inputNameValidation: 'ok'
      });
    }
  }
  inputCodeValidation = (focus) => {
    if (focus === false) {
      if (this.state.code.trim().length > 0 && this.state.code.trim().length < 3) {
        this.setState({
          inputCodeValidation: 'err'
        });
      } else {
        this.setState({
          inputCodeValidation: 'ok'
        });
      }
    }
    if (focus === true) {
      this.setState({
        inputCodeValidation: 'ok'
      });
    }
  }
  inputDataValidation = (focus) => {
    if ((focus === false) && this.state.valid.length === 5) {
      let currYear = 0;
      let curMon = 0;
      const inputYear = this.state.valid.slice(this.state.valid.indexOf('/') + 1, this.state.valid.length);
      const inputMon = this.state.valid.slice(0, this.state.valid.indexOf('/'));

      if (this.state.valid.length === 5) {
        currYear = new Date().getFullYear().toString().substr(-2);
        curMon = new Date().getMonth() + 1;
      }
      if ((this.state.valid.length === 5) && ((inputMon > 12) ||
        (inputYear < currYear) ||
        (Number(inputMon) === 0) ||
        ((inputYear === currYear) &&
        (inputMon < curMon)))) {
        this.setState({
          inputDataValidation: 'err'
        });
      } else {
        this.setState({
          inputDataValidation: 'ok'
        });
      }
    }
    if ((focus === false) && (this.state.valid.length > 0 && this.state.valid.length < 5)) {
      this.setState({
        inputDataValidation: 'err'
      });
    }
    if (((focus === false) && this.state.valid.length === 0) || focus === true) {
      this.setState({
        inputDataValidation: 'ok'
      });
    }
  }

  inputCardNumberOnFocus = (focus) => {
    if (focus === false &&
      this.state.card.replace(/\s/g, '').length > 0 &&
      this.state.card.replace(/\s/g, '').length < 16) {
      this.setState({
        inputCardNumberValidation: 'err'
      });
    } else {
      this.setState({
        inputCardNumberValidation: 'ok'
      });
    }
  }
  savePayment = () => {
    this.props.sendPayment((approved) => {
      this.setState({ approved, successfulPayment: true });
    }, {
      number: this.state.card,
      brand: this.state.brand.trim(),
      valid: this.state.valid,
      code: this.state.code
    });
  }

  backHandl = () => {
    // eslint-disable-next-line
    this.props.history.goBack();
  }


  inputCardChange = (e) => {
    this.setState({ [e.target.name]: e.target.value.replace(/ \//g, '') });
  }
  redirectTo = () => {
    // eslint-disable-next-line
    this.props.history.replace(URLS.PROFILECARS);
  }

  renderDate = () => {
    const time = moment(this.state.approved.date).format('h:mm A');
    const year = moment(this.state.approved.date).format('DD/MM/YYYY');
    // const year = moment(this.state.approved.date).format('MMMM YYYY');

    return `${time} ${year}`;
  }


  render() {
	  return (
  <React.Fragment>
    <Modal isOpen={this.state.isOpen}>
      <div className="page-payments">
        <ModalHeader backHandl={this.backHandl}>
          <i className="ion-locked" /> Pay deposit
        </ModalHeader>
        <PageTitle>
				  To reserve a car for you we require <b>$200</b> deposit
        </PageTitle>

        <div className="payment">
          <div className={`input-wrp ${this.state.card.length !== 0 ? '-active' : ''} -${this.state.inputCardNumberValidation}`}>

            <InputMask
              maskChar=" "
              value={this.state.card}
              onChange={this.inputCardChange}
              type="tel"
              className={`inpt -${this.state.inputCardNumberValidation}`}
              name="card"
              mask="9999 9999 9999 9999"
              id="input1"
              autoComplete="off"
              onFocus={() => this.inputCardNumberOnFocus(true)}
              onBlur={() => this.inputCardNumberOnFocus(false)}
            />
            <label htmlFor="input1" className={`lbl ${this.state.card.length !== 0 ? '-active' : ''}`}>
                Card number
            </label>
            <p className="error-text-card">
              { this.state.inputCardNumberValidation === 'err' ? 'Please provide full data' : ''}
            </p>
          </div>
          <div className={`input-wrp ${this.state.brand.length !== 0 ? '-active' : ''} -${this.state.inputNameValidation}`}>

            <input
              value={this.state.brand}
              onChange={this.inputCardChange}
              type="text"
              className={`inpt -${this.state.inputNameValidation}`}
              name="brand"
              id="input2"
              autoComplete="off"
              onFocus={() => this.inputNameValidation(true)}
              onBlur={() => this.inputNameValidation(false)}
            />
            <label htmlFor="input2" className={`lbl ${this.state.brand.length !== 0 ? '-active' : ''}`}>
                Cardholder name
            </label>
            <p className="error-text-name">
              { this.state.inputNameValidation === 'err' ? 'Please provide correct name' : ''}
            </p>
          </div>

          <div className="double">
            <div className={`input-wrp ${this.state.valid.length !== 0 ? '-active' : ''} -${this.state.inputDataValidation}`}>
              <InputMask
                maskChar=""
                value={this.state.valid}
                onChange={this.inputCardChange}
                type="tel"
                className={`inpt -${this.state.inputDataValidation}`}
                name="valid"
                mask="99/99"
                id="input3312312"
                autoComplete="off"
                onFocus={() => this.inputDataValidation(true)}
                onBlur={() => this.inputDataValidation(false)}
              />
              <p className="error-text">
                { this.state.inputDataValidation === 'err' ? 'Please provide correct data' : ''}
              </p>

              <label htmlFor="input3312312" className={`lbl ${this.state.valid.length !== 0 ? '-active' : ''}`}>
                valid thru
              </label>
            </div>
            <div className={`input-wrp ${this.state.code.length !== 0 ? '-active' : ''} -${this.state.inputCodeValidation}`}>
              <InputMask
                maskChar=" "
                value={this.state.code}
                onChange={this.inputCardChange}
                type="tel"
                className={`inpt -${this.state.inputCodeValidation}`}
                name="code"
                mask="9999"
                id="input431231231"
                autoComplete="off"
                onFocus={() => this.inputCodeValidation(true)}
                onBlur={() => this.inputCodeValidation(false)}
              />
              <label htmlFor="input431231231" className={`lbl ${this.state.code.length !== 0 ? '-active' : ''}`}>
                Security code
              </label>
              <p className="error-text-code">
                { this.state.inputCodeValidation === 'err' ? 'Please provide correct code' : ''}
              </p>
            </div>
          </div>
        </div>
        <Button
          disabled={this.state.card.length <= 18
          || this.state.code === ''
          || this.state.brand === ''
          || this.state.valid === ''
          || this.state.valid.length < 5
          || this.state.inputDataValidation === 'err'
          || !RegExp(/^\w+\s+[\w-.]+$|^\w+\s+[\w-.]+\s+[\w-.]+$/g).test(this.state.brand.trim())
          || this.state.brand.trim().length > 100
          || this.state.inputNameValidation === 'err'
          || this.state.code.trim().length < 3
          || this.state.code.trim().length > 4
          || this.state.card.replace(/\s/g, '').length !== 16
          || this.state.inputCardNumberValidation === 'err'
          }
          onClick={this.savePayment}
        >
              Pay $200 deposit
        </Button>

      </div>
    </Modal>
    <Modal isOpen={this.state.successfulPayment} >
      <div className="page-payments -ok">
        <ModalHeader backHandl={this.redirectTo} iconType="cross">
          {''}
        </ModalHeader>

        <PageTitle>
					We received <br /> your payment
        </PageTitle>

        <p className="payment-balance">
					Account balance: <b>$200</b>
        </p>
        <br />
        <p className="payment-date">
					At <b>{ this.state.approved.date ? this.renderDate() : null }</b>
        </p>
        <div className="payment-car">
          <CarItem
            name={this.state.approved.car && this.state.approved.car.heading}
            perMounth={this.state.approved.car && this.state.approved.car.perMounth
              ? this.state.approved.car.perMounth : 0}

            image={this.state.approved.car && this.state.approved.car.media
              && this.state.approved.car.media.photo_links
              && this.state.approved.car.media.photo_links.length
              ? this.state.approved.car.media.photo_links[0] : null
            }
          />
        </div>
        <p className="payment-receive">
          Will be delivered to:
          <div>
            {this.state.approved.address}
          </div>
          <br />
          Customer support:
          <p className="payment-balance">
            +1 (855) 562-6618
          </p>
        </p>

        <Button
          onClick={this.redirectTo}
          inline
          disabled={false}
        >
          Return to home page
        </Button>
        {/* <a className="payment-link">
          <i className="icon-envelope" />
					Email me delivery details
        </a> */}
        {/* <a className="payment-link">
          <i className="icon-calendar" />
					Add this date to my calendar
        </a> */}
      </div>
    </Modal>
  </React.Fragment>
	  );
  }
}

Payment.propTypes = {
  // getPayPal: PropTypes.func.isRequired,
  sendPayment: PropTypes.func.isRequired
};

export default connect(null, containerActions)(Payment);



// WEBPACK FOOTER //
// ./src/pages/Payment/index.js